export async function setFloatCap(
  state,
  { data, type = "low_cap_stocks", res }
) {
  state.floatCapData = data;
  state.floatCapType = type;
  state.floatRes = res;
  state.highCapStocks = data["high_cap_stocks"]
    .filter((i) => parseInt(i.float_cap) != 0)
    ?.map((i) => i.symbol);
  state.midCapStocks = data["mid_cap_stocks"]
    .filter((i) => parseInt(i.float_cap) != 0)
    ?.map((i) => i.symbol);
  state.lowCapStocks = data["low_cap_stocks"]
    .filter((i) => parseInt(i.float_cap) != 0)
    ?.map((i) => i.symbol);
  state.ultraLowCapStocks = data["ultra_low_cap_stocks"]
    .filter((i) => parseInt(i.float_cap) != 0)
    ?.map((i) => i.symbol);
}
export async function setSignals(state, signals) {
  state.signalList = signals;
}
export function setSignalsPreview(state, data) {
  state.signalCounts = data;
}
export function setBrokerData(state, data) {
  state.brokerData = data;
}
export function setCandleStickPatterns(state, signals) {
  state.candleStickPatterns = signals;
}
export function setMySignals(state, signals) {
  state.mySignals = signals;
}
export function setAllSymbols(state, allSymbols) {
  state.allSymbols = allSymbols;
}
export function setAllStocks(state, allStocks) {
  state.allStocks = allStocks;
}
export function setAllSectors(state, allSectors) {
  state.allSectors = allSectors;
}
export function setAllBroker(state, allBrokers) {
  state.allBrokers = allBrokers;
}
export function setSectorDetails(state, sectorDetails) {
  state.sectorDetails = sectorDetails;
}
export function setHistoryDataSearch(state, historyData) {
  state.historyDataSearch = historyData.reverse().map((row, index) => {
    if (index > 0) {
      const prev_close = historyData[index - 1].close;
      row.change = (row.close - prev_close) / prev_close;
    } else {
      row.change = 0;
    }
    return row;
  });
  state.historyDataSearch = state.historyDataSearch.reverse();
}

export function setLatestFiscalYearQuarter(state, latestFiscalYearQuarter) {
  state.latestFiscalYearQuarter = latestFiscalYearQuarter;
}

export function setFloatCapDataSymbol(state, { symbol, data }) {
  state.floatCapDataSymbol[symbol] = data;
}
